<template>
  <Modal
    ref="modalRef"
    :name="id"
    :classes="['custom-modal', ...modalClass.split(' ')]"
    :reset="true"
    :clickToClose="false"
    :hideOverlay="true"
    :draggable="draggable"
    :resizable="resizable"
    :minWidth="minWidth"
    :minHeight="minHeight"
    @beforeOpen="emit('beforeOpen')"
    @opened="emit('opened')"
    @closed="emit('closed')"
    @beforeClose="onBeforeClose"
  >
    <div class="custom-modal__header">
      <slot
        name="header"
        :hide="hide"
      />
    </div>
    <div class="custom-modal__body">
      <slot name="body" />
    </div>
  </Modal>
</template>

<script setup lang="ts">
/** AI chat window without the overlay: dragged by the `draggable` selector, resized when `resizable`, kept open while `preventClose`. */
import { ref } from "vue"

import { useModal } from "@/plugins/vue-js-modal/index"

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  modalClass: {
    type: String,
    default: ""
  },
  draggable: {
    type: [Boolean, String],
    default: false
  },
  resizable: {
    type: Boolean,
    default: false
  },
  minWidth: {
    type: Number,
    default: 0
  },
  minHeight: {
    type: Number,
    default: 0
  },
  preventClose: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(["beforeOpen", "opened", "closed"])

const modal = useModal()
const modalRef = ref<{ resetLayout: () => void } | null>(null)

function onBeforeClose(event: { cancel: () => void }) {
  if (props.preventClose) event.cancel()
}

function hide() {
  modal.hide(props.id)
}

/** Drops a manual resize and drag so the window returns to its CSS size and position. */
function resetLayout() {
  modalRef.value?.resetLayout()
}

defineExpose({ hide, resetLayout })
</script>
